import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@ui";
import { useAuth } from "@domain/auth/useAuth";
import { WorkspaceLoading } from "@screens/workspace/WorkspaceLoading";
import { ROUTES } from "@shared/routes";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading, verificationFailed, checkAuthStatus } = useAuth();

  if (isLoading) {
    return <WorkspaceLoading />;
  }

  if (!isAuthenticated && verificationFailed) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
        <p className="text-ink-body">{t("auth.sessionCheck.unavailable")}</p>
        <Button onClick={() => checkAuthStatus()}>{t("auth.sessionCheck.retry")}</Button>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.login} replace />;
  }

  return <>{children}</>;
}
